import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { getServerURL } from "../utils/funcs/get-serverURL";
import styles from "../styles/claim-certificate.module.scss";

export default function ClaimCertificatePage() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id") || "";
  const serverURL = getServerURL();

  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState<{ success: boolean } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${serverURL}/eicr/claim-certificate`, {
        id,
        mobile: mobile.trim(),
        email: email.trim().toLowerCase(),
      });

      if (response.data.success) {
        setResult(response.data);
      } else {
        setError(response.data.error || "Something went wrong. Please try again.");
      }
    } catch (err: any) {
      const msg = err?.response?.data?.error || "Something went wrong. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!id) {
    return (
      <div className={styles.container}>
        <p className={styles.error}>Invalid link. Please check the SMS you received and try again.</p>
      </div>
    );
  }

  if (result) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.heading}>Email Sent</h1>
          <p>Your EICR certificate has been emailed to you.</p>
          <p>Please check your inbox. If you don't see it, please check your junk or spam folder.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.heading}>Get Your EICR Certificate</h1>
        <p className={styles.subheading}>
          Enter the mobile number we texted and your email address to receive your certificate.
        </p>
        <form onSubmit={handleSubmit} className={styles.form}>
          <label htmlFor="mobile">Mobile number</label>
          <input
            id="mobile"
            type="tel"
            placeholder="e.g. 07700 900000"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          <label htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && <p className={styles.error}>{error}</p>}
          <button type="submit" disabled={loading} className={styles.button}>
            {loading ? "Verifying..." : "Get Certificate"}
          </button>
        </form>
      </div>
    </div>
  );
}
